import {
  useCustomProxyCountUrlState,
  useProxyCountUrlState,
} from "@/hooks/urlState";

export default function useGetTotalNumProxies() {
  const [customProxyCount] = useCustomProxyCountUrlState();
  const [proxyCount] = useProxyCountUrlState();

  const totalNumberOfProxies = proxyCount === 0 ? customProxyCount : proxyCount;

  return { totalNumberOfProxies };
}
